import React from 'react';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import OrangeLogo from '../icons/OrangeLogo';
import { FindMoreButton } from '../../pages/Home/HomeFeatures/FindMoreButton';

const OrangeContentDescription = () => {
    return (<div>
        <OrangeLogo style={{ width: '3rem', height: '3rem', marginTop: '1rem' }} />

        <Typography variant='h4'>
            <FormattedMessage id='orange.contentTitle' />
        </Typography>
        <Typography variant='h5'>
            <FormattedMessage id='orange.contentDescription' />
        </Typography>
        <a href='https://www.platformadigitaliada.ro/' target='_blank' rel={'noopener'}>
            <FindMoreButton textId={'orange.linkDescription'} />
        </a>
    </div>);
};

export default OrangeContentDescription;